import DropdownTemplateView from '../../../../DropdownTemplateView'
import {HierarchyLevels} from 'constants'
import $ from 'jquery'
import SimpleMenu, { Option } from '../../../../components/SimpleMenu'

export default class RevokeMenu extends DropdownTemplateView {
    constructor() {
        super()

        this.onItemSelected = () => {}

        this.state = {
            hierarchyLevel: HierarchyLevels.TASK,
            assignTextsMap: {},
            revokeTextsMap: {},
        }

        this.onAnyStatePropertyChanged(['hierarchyLevel', 'assignTextsMap', 'revokeTextsMap'], (level) => {
            this.$grantTitleButtonButton.setState({
                title: this.state.assignTextsMap[level.hierarchyLevel],
            })
            this.$revokeTitleButtonButton.setState({
                title: this.state.revokeTextsMap[level.hierarchyLevel],
            })
        })
    }

    static getInstance() {
        return getInstance()
    }

    templateHtml() {
        return "<div class='chooseAccessMenuContainer'/>"
    }

    afterRender() {
        this.simpleMenu = new SimpleMenu({
            additionalClass: 'chooseAccessMenu',
        }).init(this.$el)

        this.$grantTitleButtonButton = new Option({
            onSelected: () => this.onItemSelected(true),
            additionalClass: 'grantTitle',
        }).init(this.simpleMenu.$el)
        this.$revokeTitleButtonButton = new Option({
            onSelected: () => this.onItemSelected(false),
            additionalClass: 'revokeTitle',
        }).init(this.simpleMenu.$el)
    }

    setCallback(callback) {
        this.onItemSelected = callback
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
    }
}

let instance = null
const getInstance = () => {
    if (!instance) {
        instance = new RevokeMenu().init($('body'))
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/RevokeMenu.js